// extracted by mini-css-extract-plugin
module.exports = {"notificationList":"NewsLetterList_notificationList__8WA_i","itemBlock":"NewsLetterList_itemBlock__oiF4p"};